import {Body1, Body2} from "@fluentui/react-components";

export const privacyLanguages = {
    nl: {
        title: "Privacyverklaring Klokking",
        intro:
            "Dit is een privacyverklaring van Klokking. Deze privacyverklaring omschrijft welke vereniging- en persoonsgegevens wij verwerken, voor welke doeleinden deze gegevens worden gebruikt en welke maatregelen wij hebben getroffen om de verwerking rechtmatig, behoorlijk en transparant te laten plaatsvinden conform de eisen van de Algemene Verordening Gegevensbescherming.",

        sections: [
            {
                number: "1.",
                title: "Gebruik van persoonsgegevens",
                content: (
                    <>
                        <Body1>Wij verwerken de volgende persoonsgegevens indien u gebruik maakt van het inschrijfplatform van Klokking.</Body1>
                        <br /><br />
                        <Body2><strong>Wij verzamelen de volgende gegevens:</strong></Body2>
                        <ul>
                            <li>Naam en contactgegevens van de vereniging</li>
                            <li>Naam, e-mail en telefoonnummer van de contactpersoon(en)</li>
                            <li>Naam, leeftijd en licentienummers van ingeschreven personen</li>
                        </ul>
                        <Body2><strong>Wij gebruiken deze gegevens voor:</strong></Body2>
                        <ul>
                            <li>Inschrijving voor wedstrijden (gedeeld met de organiserende vereniging)</li>
                            <li>Facturering door de organiserende vereniging</li>
                            <li>Contact met u opnemen of onderhouden</li>
                        </ul>
                    </>
                ),
            },
            {
                number: "2.",
                title: "Toegang tot uw gegevens",
                content: (
                    <>
                        <Body1>Klokking hecht grote waarde aan de bescherming van uw gegevens. Daarom gelden de volgende regels voor de toegang tot uw inschrijvingsgegevens:</Body1>
                        <ul>
                            <li>Alleen de organiserende vereniging (event-eigenaar) van het wedstrijd waarbij u bent ingeschreven, kan uw inschrijvingsgegevens inzien.</li>
                            <li>Event-eigenaren zien uitsluitend de deelnemers die zijn ingeschreven voor hun eigen event — niet die van andere evenementen.</li>
                            <li>Event-eigenaren kunnen een inschrijving wijzigen (bijv. categorie of status), maar kunnen uw persoonlijke deelnemersgegevens niet aanpassen of verwijderen.</li>
                            <li>Klokking leest, gebruikt of deelt uw gegevens nooit voor andere doeleinden dan het faciliteren van het inschrijfproces.</li>
                        </ul>
                    </>
                ),
            },
            {
                number: "3.",
                title: "Informatie, wijziging, correctie, wissen en bezwaar",
                content: (
                    <>
                        <Body1>
                            U kunt contact opnemen via{" "}
                            <span className="privacy-email">klokking@pm.me</span> voor:
                        </Body1>
                        <ul>
                            <li>Meer informatie over hoe wij persoonsgegevens verwerken</li>
                            <li>Vragen naar aanleiding van deze privacyverklaring</li>
                            <li>Bezwaar tegen het gebruik van uw gegevens</li>
                        </ul>
                        <br />
                        <Body2><strong>Wissen van gegevens:</strong></Body2>
                        <ul>
                            <li>Indien inschrijvingen worden verwijderd via het inschrijfplatform, zijn deze definitief verwijderd.</li>
                            <li>Reeds gewiste gegevens zijn niet opvraagbaar.</li>
                            <li>Om verenigingsdata te verwijderen, neem contact op via <span className="privacy-email">klokking@pm.me</span>.</li>
                        </ul>
                        <br />
                        <Body2><strong>Overdracht van gegevens:</strong></Body2>
                        <ul>
                            <li>De organiserende vereniging ontvangt uw inschrijvingsgegevens voor de wedstrijd en is verantwoordelijk voor de verdere verwerking en beveiliging daarvan.</li>
                            <li>Voor andere doeleinden worden uw gegevens nooit gedeeld.</li>
                        </ul>
                    </>
                ),
            },
            {
                number: "4.",
                title: "Beveiliging van uw gegevens",
                content: (
                    <>
                        <Body1>
                            Wij treffen adequate technische en organisatorische maatregelen om uw gegevens te beveiligen en gebruiken uw gegevens uitsluitend voor de genoemde doeleinden.
                        </Body1>
                        <br /><br />
                        <Body2><strong>Gegevensopslag:</strong></Body2>
                        <ul>
                            <li>Gegevens op het inschrijfplatform worden opgeslagen via <strong>Supabase</strong>, een beveiligd cloudplatform.</li>
                            <li>Gegevens binnen het race-systeem worden lokaal opgeslagen op uw apparaat via <strong>Dexie</strong> (IndexedDB). Deze gegevens verlaten uw apparaat niet, tenzij u deze zelf deelt.</li>
                        </ul>
                    </>
                ),
            },
            {
                number: "5.",
                title: "Derden",
                content: (
                    <Body1>
                        Klokking verstrekt uw gegevens uitsluitend aan de organiserende verenigingen die zijn aangemeld bij Klokking, en nooit aan externe derden. Alleen contactgegevens en de daadwerkelijk gedane inschrijvingen worden gedeeld met de organiserende vereniging.
                    </Body1>
                ),
            },
            {
                number: "6.",
                title: "Bewaren van uw gegevens",
                content: (
                    <Body1>
                        Wij bewaren uw gegevens niet langer dan noodzakelijk voor het doel van de verwerking of zoals vereist door wetgeving. Jaarlijks worden alle gegevens met betrekking tot inschrijvingen voor gehouden events verwijderd uit de database van Klokking. Ledengegevens binnen een vereniging worden niet automatisch verwijderd en zijn herbruikbaar voor toekomstige inschrijvingen.
                    </Body1>
                ),
            },
            {
                number: "7.",
                title: "Wijzigingen privacyverklaring",
                content: (
                    <Body1>
                        Het kan voorkomen dat deze verklaring in de toekomst wordt gewijzigd. Wij raden aan om deze privacyverklaring regelmatig te raadplegen zodat u op de hoogte bent van eventuele wijzigingen.
                    </Body1>
                ),
            },
        ],

        updated: "Laatst bijgewerkt: 2026",
    },

    en: {
        title: "Privacy Policy Klokking",
        intro:
            "This is the privacy policy of Klokking. This policy describes which association and personal data we process, for what purposes this data is used, and what measures we have taken to ensure processing is lawful, fair, and transparent in accordance with the requirements of the General Data Protection Regulation (GDPR).",

        sections: [
            {
                number: "1.",
                title: "Use of personal data",
                content: (
                    <>
                        <Body1>We process the following personal data when you use the Klokking registration platform.</Body1>
                        <br /><br />
                        <Body2><strong>We collect the following data:</strong></Body2>
                        <ul>
                            <li>Name and contact details of the association</li>
                            <li>Name, email, and phone number of the contact person(s)</li>
                            <li>Name, age, and license numbers of registered participants</li>
                        </ul>
                        <Body2><strong>We use this data for:</strong></Body2>
                        <ul>
                            <li>Registration for competitions (shared with the organizing association)</li>
                            <li>Invoicing by the organizing association</li>
                            <li>Contacting or maintaining contact with you</li>
                        </ul>
                    </>
                ),
            },
            {
                number: "2.",
                title: "Access to your data",
                content: (
                    <>
                        <Body1>Klokking places great importance on protecting your data. The following rules apply to access to your registration data:</Body1>
                        <ul>
                            <li>Only the organizing association (event owner) of the competition you are registered for can view your registration data.</li>
                            <li>Event owners can only see participants registered for their own event — not those of other events.</li>
                            <li>Event owners can modify a registration (e.g. category or status), but cannot change or delete your personal participant data.</li>
                            <li>Klokking never reads, uses, or shares your data for purposes other than facilitating the registration process.</li>
                        </ul>
                    </>
                ),
            },
            {
                number: "3.",
                title: "Information, correction, deletion, and objection",
                content: (
                    <>
                        <Body1>
                            You can contact us at{" "}
                            <span className="privacy-email">klokking@pm.me</span> for:
                        </Body1>
                        <ul>
                            <li>More information about how we process personal data</li>
                            <li>Questions regarding this privacy policy</li>
                            <li>Objections to the use of your data</li>
                        </ul>
                        <br />
                        <Body2><strong>Deletion of data:</strong></Body2>
                        <ul>
                            <li>If registrations are deleted via the registration platform, they are permanently removed.</li>
                            <li>Data that has already been deleted cannot be retrieved.</li>
                            <li>To delete association data, please contact us at <span className="privacy-email">klokking@pm.me</span>.</li>
                        </ul>
                        <br />
                        <Body2><strong>Transfer of data:</strong></Body2>
                        <ul>
                            <li>The organizing association receives your registration data for the competition and is responsible for its further processing and security.</li>
                            <li>Your data is never shared for any other purposes.</li>
                        </ul>
                    </>
                ),
            },
            {
                number: "4.",
                title: "Security of your data",
                content: (
                    <>
                        <Body1>
                            We take adequate technical and organizational measures to secure your data and use it solely for the stated purposes.
                        </Body1>
                        <br /><br />
                        <Body2><strong>Data storage:</strong></Body2>
                        <ul>
                            <li>Data on the registration platform is stored via <strong>Supabase</strong>, a secure cloud platform.</li>
                            <li>Data within the race system is stored locally on your device via <strong>Dexie</strong> (IndexedDB). This data does not leave your device unless you share it yourself.</li>
                        </ul>
                    </>
                ),
            },
            {
                number: "5.",
                title: "Third parties",
                content: (
                    <Body1>
                        Klokking only shares your data with organizing associations that are registered with Klokking, and never with external third parties. Only contact details and the actual registrations are shared with the organizing association.
                    </Body1>
                ),
            },
            {
                number: "6.",
                title: "Retention of your data",
                content: (
                    <Body1>
                        We do not retain your data longer than necessary for the purpose of processing, or as required by law. All data related to registrations for past events is deleted annually from the Klokking database. Member data within an association is not automatically deleted and can be reused for future registrations.
                    </Body1>
                ),
            },
            {
                number: "7.",
                title: "Changes to this privacy policy",
                content: (
                    <Body1>
                        This policy may be updated in the future. We recommend reviewing this privacy policy regularly to stay informed of any changes.
                    </Body1>
                ),
            },
        ],

        updated: "Last updated: 2026",
    },
};